
    import { makeI18n } from '@/services/i18n';
    const baseTranslation = undefined
    
    
    if(module.hot) {
      const bucket = require("/app/build/i18n/browser-bucket.js");
      bucket.add('src/components/user-menu/user-menu.vue', {"my_profile":{"ru_RU":"Мой профиль","en_US":"My profile"},"settings":{"ru_RU":"Настройки Хантфлоу","en_US":"Huntflow settings"},"logout":{"ru_RU":"Выйти","en_US":"Logout"},"unsudo":{"ru_RU":"Выйти из sudo","en_US":"Exit sudo mode"},"add_organization":{"ru_RU":"Добавить организацию","en_US":"Add Company"},"help":{"ru_RU":"Руководство пользователя","en_US":"User manual"},"accounting_documents":{"ru_RU":"Бухгалтерские документы","en_US":"Accounting documents"}}) 
    }
   
    
    export default function (Component) {
      function beforeCreateI18n() {
        this.$i18n = this.$options._i18n;
      }

      function addHook(current) {
        if (Array.isArray(current)) {
          return [beforeCreateI18n].concat(current);
        } 
        if (current) {
          return [beforeCreateI18n, current];
        }
        return [beforeCreateI18n];
      }
    
      Component.options._i18n = makeI18n("src/components/user-menu/user-menu.vue", baseTranslation);
      Component.options.beforeCreate = addHook(Component.options.beforeCreate);
      delete Component.options._Ctor;
    }
  